import { getLocalStorageData } from '../../../utils/helper';
import { APP_API_URL_V2 } from '../../../utils/xhr-instance';
import { axiosInstanceV2 } from '../../axios';

export async function getSubscriptions() {
	const API_URL = `${APP_API_URL_V2}/subscription/details`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response.data);
}

export async function getPlanUsages() {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/usage`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response.data);
}

export async function getSubscriptionPlans() {
	const API_URL = `${APP_API_URL_V2}/plans/`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response.data);
}
